import classNames from 'classnames';
import React from 'react';
import { SendComponent } from 'ui/Icons';

interface ISendButtonProps {
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}
export const SendButton: React.FC<ISendButtonProps> = ({ disabled, className, onClick }) => {
  const sendButtonClassName = classNames(
    'flex justify-center items-center select-none uppercase font-pt-sans text-[15px] font-normal tracking-wide outline-none border-solid bg-brown-prime rounded-[4px]',
    'min-h-[35px] max-h-[35px] min-w-[42px] max-w-[42px]',
    {
      'cursor-pointer': !disabled,
      'hover:bg-brown-prime text-white opacity-40 ': disabled,
      'text-ivory': !disabled,
      'hover:bg-green-prime active:border-solid active active:border-green-prime-20 active:bg-green-prime': !disabled,
    },
    className,
  );

  return (
    <button className={sendButtonClassName} disabled={disabled} onClick={onClick}>
      <SendComponent />
    </button>
  );
};